import { render, staticRenderFns } from "./ClientActionModal.vue?vue&type=template&id=38b38d24&"
import script from "./ClientActionModal.vue?vue&type=script&lang=js&"
export * from "./ClientActionModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientActionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports